var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#CC1010"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#D5D9E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.45438V16.5456C17.4997 16.7986 17.399 17.0412 17.2201 17.2201C17.0412 17.399 16.7986 17.4997 16.5456 17.5H7.45438C7.20136 17.4997 6.9588 17.399 6.7799 17.2201C6.60099 17.0412 6.50033 16.7986 6.5 16.5456V7.45438C6.50033 7.20136 6.60099 6.9588 6.7799 6.7799C6.9588 6.60099 7.20136 6.50033 7.45438 6.5H16.5456C16.7986 6.50033 17.0412 6.60099 17.2201 6.7799C17.399 6.9588 17.4997 7.20136 17.5 7.45438Z",
    fill: "#F9FBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndLocation);
export default __webpack_public_path__ + "static/media/endLocation.675abfecbb21b4afd3fe64f2d3493089.svg";
export { ForwardRef as ReactComponent };